module.exports = __webpack_public_path__ + "img/wzf_13.d141ea30.png";